jQuery(document).ready(function ($) {
  jQuery("a[href='#']").attr("href", "javascript:void(0)");
  var catItems = document.querySelectorAll(
    ".widget_categories nav ul .cat-item"
  );
  if (catItems.length > 0) {
    catItems.forEach((element) => {
      var newHtml = element.innerText;
      var linkItem = element.querySelector("a");
      linkItem.classList.add("btn");
      linkItem.innerHTML = "<span>" + newHtml + "</span>";
    });
  }
  jQuery(document).on(
    "click",
    ".site-header .primary_mobile_menu",
    function () {
      if (jQuery(this).hasClass("active")) {
        jQuery("body").removeClass("mobile_menu_open");
        jQuery(this).removeClass("active");
        jQuery(this).find(".menu_link_text").text("Menu");
      } else {
        jQuery("body").addClass("mobile_menu_open");
        jQuery(this).addClass("active");
        jQuery(this).find(".menu_link_text").text("Close");
      }
    }
  );

  jQuery(document).on(
    "click",
    ".site-header .menu-item.menu-item-has-children>a",
    function () {
      if (jQuery(this).parent().find(".sub-menu").is(":hidden")) {
        jQuery(".site-header .menu-item.menu-item-has-children>a").removeClass(
          "active"
        );
        jQuery(
          ".site-header .menu-item.menu-item-has-children>.sub-menu"
        ).slideUp();
        jQuery(this).addClass("active");
        jQuery(this).parent().find(".sub-menu").slideDown();
      } else {
        jQuery(this).removeClass("active");
        jQuery(this).parent().find(".sub-menu").slideUp();
      }
    }
  );

  $(".pricing_plans__lists > .plan_list").each(function (index) {
    $(this).slick({
      infinite: false,
      slidesToShow: 3,
      arrows: false,
      variableWidth: true,
      centerPadding: false,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            variableWidth: false,
            // centerMode: true,
          },
        },
        {
          breakpoint: 1360,
          settings: {
            variableWidth: true,
            centerMode: true,
            // slidesToShow: 3,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            variableWidth: true,
            centerMode: true,
            slidesToShow: 1,
            // centerPadding: '50px',
          },
        },
      ],
    });
    $(this).slick("slickGoTo", 1);
  });

  jQuery(document).on("click", ".scrolltodiv", function (event) {
    event.preventDefault();
    var target = this.getAttribute("data-target");
    jQuery("html, body").animate(
      {
        scrollTop: jQuery(target).offset().top - 140,
      },
      1000
    );
  });

  $(".hero_banner_slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: false,
    infinite: true,
    autoplaySpeed: 4000,
  });

  $(".trusted_top_brands_logo_slider").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 4000,
    pauseOnHover: false,
    cssEase: "linear",
    pauseOnFocus: false,
    pauseOnHover: false,
    arrows: false,
    dots: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 1520,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $slider_prev_arrow =
    '<div class="slick-prev"><svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="17.5" cy="17.5" r="17.5" transform="matrix(-1 0 0 1 35 0)" fill="#505356"/><path d="M20.7236 17.5H14.2763M14.2763 17.5L17.4999 14.2763M14.2763 17.5L17.4999 20.7237" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>';

  $slider_next_arrow =
    '<div class="slick-next"><svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="17.5" cy="17.5" r="17.5" fill="#505356"/><path d="M14.2764 17.5H20.7237M20.7237 17.5L17.5001 14.2763M20.7237 17.5L17.5001 20.7237" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>';

  $(".testimonial_slider").slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    dots: true,
    prevArrow: $slider_prev_arrow,
    nextArrow: $slider_next_arrow,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: true,
    appendArrows: ".testimonial_slider_control .slider_arrows_section",
    appendDots: ".testimonial_slider_control .slider_dots_section",
    responsive: [
      {
        breakpoint: 1360,
        settings: {
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          dots: false,
          autoplay: false,
        },
      },
    ],
  });

  $(".four_column_cards_icon_slider").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: $slider_prev_arrow,
    nextArrow: $slider_next_arrow,
    variableWidth: true,
    autoplay: false,
    autoplaySpeed: 4000,
    infinite: true,
    appendArrows:
      ".four_column_cards_icon_slider_control .slider_arrows_section",
  });

  jQuery(".component_accordion_section .accordion_heading_section").on(
    "click",
    function () {
      if (
        jQuery(this)
          .closest(".accordion_item_inner")
          .find(".accordion_content")
          .is(":hidden")
      ) {
        jQuery(this)
          .closest(".component_accordion_section")
          .find(".accordion_content")
          .slideUp();
        jQuery(this)
          .closest(".component_accordion_section")
          .find(".accordion_item_inner")
          .removeClass("active");
        jQuery(this)
          .closest(".accordion_item_inner")
          .find(".accordion_content")
          .slideDown();
        jQuery(this).parent().addClass("active");
      } else {
        jQuery(this)
          .closest(".accordion_item_inner")
          .find(".accordion_content")
          .slideUp();
        jQuery(this).parent().removeClass("active");
      }
    }
  );

  jQuery(".contact_detail_accordion_section .accordion_heading_section").on(
    "click",
    function () {
      if (
        jQuery(this)
          .closest(".accordion_item_inner")
          .find(".accordion_content")
          .is(":hidden")
      ) {
        jQuery(this)
          .closest(".contact_detail_accordion_section")
          .find(".accordion_content")
          .slideUp();
        jQuery(this)
          .closest(".contact_detail_accordion_section")
          .find(".accordion_item_inner")
          .removeClass("active");
        jQuery(this)
          .closest(".accordion_item_inner")
          .find(".accordion_content")
          .slideDown();
        jQuery(this).parent().addClass("active");
      } else {
        jQuery(this)
          .closest(".accordion_item_inner")
          .find(".accordion_content")
          .slideUp();
        jQuery(this).parent().removeClass("active");
      }
    }
  );

  $(".component_tab_slider_content_with_big_and_small_image").each(function () {
    if ($(this).find(".tab_slider_for").length > 0) {
      $(this).find(".tab_slider_for").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        prevArrow: $slider_prev_arrow,
        nextArrow: $slider_next_arrow,
        appendArrows: $(this).find(".tab_slider_content_with_image_control .slider_arrows_section"),
        appendDots: $(this).find(".tab_slider_content_with_image_control .slider_dots_section"),
        fade: false,
        asNavFor: $(this).find(".tab_slider_nav"),
        draggable: false,
        swipe: false,
        swipeToSlide: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: true,
              dots: true,
              swipe: true,
              autoplay: true,
              autoplaySpeed: 4000,
              infinite: true,
            },
          },
        ],
      });
    }
    if ($(this).find(".tab_slider_nav").length > 0) {
      $(this).find(".tab_slider_nav").slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: $(this).find(".tab_slider_for"),
        dots: false,
        infinite: true,
        centerMode: false,
        focusOnSelect: true,
        variableWidth: false,
        draggable: false,
        swipeToSlide: false,
        swipe: false,
        arrows: false
      });
    }
  })

  offsetLeft();

  function offsetLeft() {
    if (jQuery(".testimonial_slider").length > 0) {
      var pastoffset = jQuery(".testimonial_slider").offset(),
        pastwindWidth = jQuery(window).width();
      jQuery(".testimonial_slider").css(
        "width",
        pastwindWidth - pastoffset.left
      );
    }

    if (jQuery(".four_column_cards_icon_slider").length > 0) {
      var pastoffset = jQuery(".four_column_cards_icon_slider").offset(),
        pastwindWidth = jQuery(window).width();
      jQuery(".four_column_cards_icon_slider").css(
        "width",
        pastwindWidth - pastoffset.left
      );
    }
  }

  $(window).load(function () {
    offsetLeft();
  });

  jQuery(window).resize(function () {
    offsetLeft();
    if (jQuery(".four_column_cards_icon_slider").length > 0) {
      var pastoffset = jQuery(".four_column_cards_icon_slider").offset(),
        pastwindWidth = jQuery(window).width();
      jQuery(".four_column_cards_icon_slider").css(
        "width",
        pastwindWidth - pastoffset.left
      );
    }

    if (jQuery(".testimonial_slider").length > 0) {
      var pastoffset = jQuery(".testimonial_slider").offset(),
        pastwindWidth = jQuery(window).width();
      jQuery(".testimonial_slider").css(
        "width",
        pastwindWidth - pastoffset.left
      );
    }
  });
});

jQuery(window).on("scroll", function ($) {
  if (jQuery(".stats_number").length > 0) {
    var numbers_section =
      jQuery(".stats_number").offset().top - window.innerHeight;
    if (numbers_section < jQuery(window).scrollTop()) {
      startnumbers();
    }
  }
});

function startnumbers() {
  jQuery(".stats_number .count").each(function () {
    var $this = jQuery(this),
      countTo = $this.attr("data-count");
    jQuery({
      countNum: $this.text(),
    }).animate(
      {
        countNum: countTo,
      },
      {
        duration: 1000,
        easing: "linear",
        step: function () {
          $this.text(Math.ceil(this.countNum).toLocaleString("en"));
        },
        complete: function () {
          $this.text(this.countNum.toLocaleString("en"));
        },
      }
    );
  });
}
